import { absoluteUrlRegex } from '../regex';

export const isAbsoluteUrl = (url?: string): boolean => (
  url !== undefined && url.match(absoluteUrlRegex) !== null
);
